import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const phredTool: Tool = {
  id: "phred-quality-score",
  name: () => m.phred_tool_name(),
  description: () => m.phred_tool_description(),
  icon: "📊",
  basePath: "/phred-quality-score",
  status: "stable",
  tags: [
    "bioinformatics",
    "sequencing",
    "fastq",
    "science",
    "phred",
    "quality-score",
  ],
};
